<template>
  <div class="factory-aftersale-bd bd" v-if="funcView.factory_after_sale_list">
    <div class="menu-wrap">
      <div class="menu-content">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right">
              <search-input :placeholder="$t('asm_factory_aftersale.ygxmlxdhsszz')" v-model="searchKey" @fetch="getMsgUserList()"></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table index type="radio" @radio="handleNodeClick" tableCode="aftersale_info" :data="userList" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
        </div>
      </div>
      <div style="width: 16px; background-color: #e4ebf2"></div>
      <div class="fun-content">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <el-button type="primary" icon="el-icon-plus" @click="editEvent" :disabled="!tableSelect.length && !userData.userId" v-if="funcView.factory_after_sale_add">{{ $t('asm_factory_aftersale.tjshgs') }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="bindEvent" :disabled="!tableSelect.length || !hasDisabled">
                <i class="icon icon-guanlian"></i>
                {{ $t('asm_factory_aftersale.swzzpd') }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="unBindEvent" :disabled="!tableSelect.length || !hasAuto">
                <i class="icon icon-quxiaoguanlian"></i>
                {{ $t('asm_factory_aftersale.qxzzpd') }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="deleteEvent" :disabled="!tableSelect.length" v-if="funcView.factory_after_sale_delete">
                <i class="icon icon-shanchu"></i>
                {{ funcView.factory_after_sale_delete }}
              </el-button>
            </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
            </el-form-item>
            <!-- 搜索栏 -->
            <el-form-item style="float: right">
              <search-input :placeholder="$t('asm_factory_aftersale.shou_hou_gong_si')" v-model="formSearch.afterServiceName" @fetch="onPageChange({ page: 1 })"  :disabled="!userData.userId" :authSearch="!userData.userId"></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table v-model="tableSelect" type="checkbox" :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
    </div>
    <factory-aftersale-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></factory-aftersale-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import factoryAftersaleDialog from './children/factory_aftersale_dialog.vue';

export default {
  name: 'factory_aftersale',
  components: { factoryAftersaleDialog },
  computed: {
    hasAuto() {
      return this.tableSelect.some(i => `${i.autoGenWorkOrder}` === '1');
    },
    hasDisabled() {
      return this.tableSelect.some(i => `${i.autoGenWorkOrder}` === '0');
    },
  },
  data() {
    return {
      provide: true,
      tableCode: 'factory_aftersale',
      searchKey: '',
      formSearch: {
        userId: '',
        afterServiceName: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },

      userList: [],
      userData: {},
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.reserFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getMsgUserList();
    this.getFuncView();
  },
  methods: {
    // 获取售后公司列表
    getMsgUserList: function () {
      this.$getJSON(apis.UserServiceRole, {
        search: this.searchKey,
        serviceRoleType: 1,
      }).then((res) => {
        this.userList = res.data;
      });
    },
    // 选中组织
    handleNodeClick: function (data) {
      this.formSearch = JSON.parse(this.reserFormSearch);
      this.userData = data;
      if (data.userId) {
        this.getTableList();
      }

    },
    // // 搜索过滤事件
    // filterTree: function () {
    //   this.$refs.tree.filter(this.searchKey);
    // },
    // // 搜索过滤
    // filterNode: function (value, data) {
    //   if (!value) {
    //     return true;
    //   }
    //   return data.userName.indexOf(value) !== -1;
    // },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.userId = this.userData.userId;
      this.$getJSON(apis.UserAreaServicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 编辑
    editEvent: function () {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_factory_aftersale.tjshgs');
      this.dialogModel.data = this.userData;
      this.dialogVisible = true;
    },
    bindEvent: function () {
      const tips = this.$t('asm_factory_aftersale.nqdyjxzdfwgsszwzzpdm');
      this.$showConfirm(tips)
        .then(() => {
          const tableSelect = this.tableSelect.filter(i => `${i.autoGenWorkOrder}` === '0');
          const params = tableSelect.map(t => t.userAreaId);
          this.$postJSON(apis.userAreaBatchUpdateAutoGenWorkOrder, { autoGenWorkOrder: 1, userAreaIds: params }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    unBindEvent: function () {
      const tips = this.$t('asm_factory_aftersale.nqdyqxxzdfwgszzpdm');
      this.$showConfirm(tips)
        .then(() => {
          const tableSelect = this.tableSelect.filter(i => `${i.autoGenWorkOrder}` === '1');
          const params = tableSelect.map(t => t.userAreaId);
          this.$postJSON(apis.userAreaBatchUpdateAutoGenWorkOrder, { autoGenWorkOrder: 0, userAreaIds: params }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    // 删除
    deleteEvent: function () {
      this.$showConfirm(this.$t('asm_factory_aftersale.nqdyscxzdshgsm'))
        .then(() => {
          const params = this.tableSelect.map(t => t.userAreaId);
          this.$postJSON(apis.UserAreaBatchDelete, { userAreaIds: params }).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.factory-aftersale-bd {
  height: 100%;
  position: relative;
  padding: 16px;

  .menu-wrap {
    display: flex;
    height: 100%;
    .menu-content {
      display: flex;
      flex-direction: column;
      flex: 3;
      padding: 0 16px;
      background-color: #ffffff;
      overflow: hidden;
    }
    .fun-content {
      display: flex;
      flex-direction: column;
      flex: 4;
      padding: 0 16px;
      background-color: #ffffff;
      overflow: hidden;
    }
  }

  .aside {
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #404040;
      padding: 14px 10px 16px 12px;
      line-height: 24px;
      .icon {
        font-weight: normal;
        float: left;
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .search {
      padding: 0 10px;
    }
    .is-current > .el-tree-node__content {
      background-color: #00afff;
      .tree-item {
        color: #ffffff;
        .icon {
          color: #ffffff;
          font-size: 12px;
        }
        .disable {
          color: #ffffff;
        }
      }
    }
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .disable {
        color: #bfbfbf;
      }
    }
  }
}
</style>
